<template>
  <div id="list" class="list">
    <draggable
      v-model="violationGroupsList"
      group="group"
      :force-fallback="true"
      ghost-class="sortable__ghost"
      @change="sortViolationGroups"
    >
      <violation-types-list-group
        v-for="group in violationGroupsList"
        :key="group.id"
        v-observe-visibility="categoryVisibleChange"
        :selected-list-group-items-status="selectedListGroupItemsStatus"
        :sticky-category-id="stickyCategoryId"
        :list-group="group"
        :filters="filters"
        @on-delete-list-group-item="$emit('on-delete-list-group-item')"
        @on-delete-list-group="$emit('on-delete-list-group')"
        @edit-group="$emit('edit-group', $event)"
        @edit-list-group-item="$emit('edit-list-group-item', $event)"
      />
    </draggable>
    <div class="reference-violation-types__list__without-group">
      <draggable
        v-model="violationList"
        group="type"
        :force-fallback="true"
        ghost-class="sortable__ghost"
        @change="onSort"
      >
        <violation-types-list-group-item
          v-for="listGroupItem in violationList"
          :key="listGroupItem.id"
          :list-group-item="listGroupItem"
          :selected-list-group-items-status="selectedListGroupItemsStatus"
          @on-delete-list-group-item="$emit('on-delete-list-group-item')"
          @edit-list-group-item="$emit('edit-list-group-item', $event)"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
import ViolationTypesListGroup from "./list-group";
import ViolationTypesListGroupItem from "./list-group-item";

export default {
  name: "list",
  components: {
    draggable,
    ViolationTypesListGroup,
    ViolationTypesListGroupItem,
  },
  props: {
    selectedListGroupItemsStatus: {
      type: String,
      default: "all",
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      categoriesInViewport: [],
      stickyCategoryId: "",
    };
  },
  computed: {
    ...mapState({
      violationGroups: (state) => state.referenceLoadTypes.violationGroups,
      violations: (state) => state.referenceLoadTypes.violations,
    }),
    violationList: {
      get() {
        return this.violations;
      },
      set(value) {
        this.$store.commit("referenceLoadTypes/setViolations", value);
      },
    },
    violationGroupsList: {
      get() {
        return this.violationGroups;
      },
      set(value) {
        this.$store.commit("referenceLoadTypes/setLastChangeWasGroupSortingValue", true);
        this.$store.commit("referenceLoadTypes/setViolationGroups", value);
      },
    },
  },
  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    const layout = document.querySelector(".layout");
    layout.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    sortViolationGroups() {
      this.$store.dispatch("referenceLoadTypes/updateGroupsSort");
    },
    categoryVisibleChange(isVisible, entry) {
      if (isVisible && !this.categoriesInViewport.includes(entry.target.id)) {
        this.categoriesInViewport.push(entry.target.id);
      }

      if (!isVisible && this.categoriesInViewport.includes(entry.target.id)) {
        this.categoriesInViewport.splice(this.categoriesInViewport.indexOf(entry.target.id), 1);
      }
    },
    handleScroll() {
      if (this.violationGroups.length > 0) {
        const layout = document.querySelector(".layout");
        this.violationGroups
          .map((category) => category.id)
          .forEach((categoryId) => {
            const el = document.getElementById(`category_${categoryId}`);

            if (
              el !== null &&
              el.offsetTop <= layout.scrollTop &&
              this.categoriesInViewport.includes(`category_${categoryId}`)
            ) {
              this.stickyCategoryId = `category_${categoryId}`;
            }
          });

        const categoriesContainer = document.getElementById("list");
        if (categoriesContainer.offsetTop >= layout.scrollTop) {
          this.stickyCategoryId = "";
        }
      }
    },
    onSortGroups() {
      this.$store.dispatch("referenceLoadTypes/updateGroupsSort");
    },
    onSort(e) {
      if (e.added) {
        this.$store.dispatch("referenceLoadTypes/changeListItemCategory", {
          categoryId: null,
          listItem: e.added.element,
        });
      }
      this.$store.dispatch("referenceLoadTypes/updateSort", null);
    },
    sortViolationsInGroup(e, group) {
      if (e.removed && !group.items.length) {
        this.openedGroups[group.id] = false;
        group.hasFouls = 0;
      }
      if (e.added) {
        this.openedGroups[group.id] = true;
        this.$store.dispatch("referenceLoadTypes/changeListItemCategory", {
          categoryId: group.id,
          listItem: e.added.element,
        });
      }
      const sortingData = group.items.map((v, vIndex) => ({ id: v.id, sort: group.items.length - vIndex }));
      this.$store.dispatch("referenceLoadTypes/changeListGroupItemsSort", sortingData);
    },
    async onGroupOpen(groupId, itemsLength) {
      if (itemsLength) {
        return;
      }

      await this.$store.dispatch("referenceLoadTypes/fetchListGroupItems", {
        categories: [groupId],
        status: this.selectedListGroupItemsStatus,
        ...this.filters,
      });
    },
    deleteGroup(groupName, groupId) {
      this.$refs.confirm.open({
        title: "Удаление категории",
        text: `Категория <b>${groupName}</b> будет удалена без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("referenceLoadTypes/deleteListGroup", groupId);
        },
      });
    },
    doesGroupHaveItems({ hasFouls, items }) {
      if (!hasFouls && !items.length) {
        return false;
      }
      if (items.length) {
        return true;
      }
      return hasFouls.toString() === "1";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.reference-violation-types__list {
  max-width: 1190px;
  &__without-group {
    margin-top: 20px;
  }
}

.sortable__ghost {
  padding: 0 !important;
  height: 0 !important;
  min-height: 0;
  border: 5px solid $color-primary !important;
  border-radius: 3px;
  content-visibility: hidden;
}

</style>
